const EGYPT_MOBILE_REGEX = /^01[0-9]{9}$/;

export interface VideoProgressSummary {
  totalVideos: number;
  watchedVideos: number;
  progress: number;
}

export interface QuizResultSummary {
  lessonName: string;
  score: number;
  submittedAt: string;
}

export interface QuizProgressSummary {
  totalQuizzes: number;
  solvedQuizzes: number;
  results: QuizResultSummary[];
}

export function toWhatsAppE164(localPhone: string): string | null {
  const digits = localPhone.replace(/\D/g, '');
  if (EGYPT_MOBILE_REGEX.test(digits)) return `20${digits.slice(1)}`;
  if (digits.startsWith('20') && digits.length === 12) return digits;
  return null;
}

export function buildParentProgressMessage(
  studentName: string,
  lessons: VideoProgressSummary | null,
  quizzes: QuizProgressSummary | null
): string {
  const lines = [
    'السلام عليكم،',
    `إحصائيات تقدم الطالب/ة: ${studentName}`,
    '',
    '📹 الدروس (الفيديوهات):',
    lessons?.totalVideos
      ? `تمت مشاهدة ${lessons.watchedVideos} من ${lessons.totalVideos} (${lessons.progress}%)`
      : 'لا توجد فيديوهات مسجلة',
    '',
    '📝 الاختبارات:',
    quizzes?.totalQuizzes
      ? `تم حل ${quizzes.solvedQuizzes} من ${quizzes.totalQuizzes}`
      : 'لا توجد اختبارات مسجلة',
  ];

  if (quizzes?.results?.length) {
    lines.push('', 'تفاصيل الاختبارات:');
    for (const result of quizzes.results) {
      const date = result.submittedAt
        ? new Date(result.submittedAt).toLocaleDateString('ar-EG', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          })
        : '';
      lines.push(`• ${result.lessonName}: ${result.score}${date ? ` (${date})` : ''}`);
    }
  }

  return lines.join('\n');
}

export function openWhatsAppToParent(parentPhone: string, message: string): boolean {
  const e164 = toWhatsAppE164(parentPhone);
  if (!e164) return false;
  window.open(
    `https://wa.me/${e164}?text=${encodeURIComponent(message)}`,
    '_blank',
    'noopener,noreferrer'
  );
  return true;
}
